import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import ListRow from 'components/ListRow'
import CommentButtons from './Comment.Buttons'
import CommentDate from './Comment.Date'
import CommentText from './Comment.Text'
import CommentUser from './Comment.User'
import './index.scss'
import { View } from 'components/View'

class Comment extends React.Component {
  static Buttons = CommentButtons

  static Date = CommentDate

  static Text = CommentText

  static User = CommentUser

  static defaultProps = {
    htmlId: null,
    isReported: null
  }

  static propTypes = {
    htmlId: PropTypes.string,
    isReported: PropTypes.bool,
    children: PropTypes.arrayOf(PropTypes.element).isRequired
  }

  render () {
    const { htmlId } = this.props
    const className = classNames({
      comment: true,
      comment_lighterText: !!this.props.isReported
    })
    return (
      <div
        className={className}
        id={htmlId}
        name={htmlId}
      >
        <ListRow
          isBorderless
          isFullWidth
        >
          <View
            style={{
              flexDirection: View.DIRECTION.ROW,
              alignItems: View.ALIGN.CENTER,
              justifyContent: View.JUSTIFY.START,
              flexWrap: 'wrap',
              width: '100%'
            }}
          >
            {this.props.children}
          </View>
        </ListRow>
      </div>
    )
  }
}

export default Comment
